import React, { useContext } from "react"

const VoiceMsgContext = React.createContext()

export const useVoiceMsg = () => {
    return useContext( VoiceMsgContext )
}

function VoiceMsgProvider({ children, message }) {
    return (
        <VoiceMsgContext.Provider value={message} >
            { children }
        </VoiceMsgContext.Provider>
    )
}

export default VoiceMsgProvider